import { computed } from "vue";
import { IssueOrder, SQDCEABName, TaskOrder, useSQDCGlobalSettingsQuery } from "@/graphql";

export function useSQDCGlobalSettings() {
  const query = useSQDCGlobalSettingsQuery({
    fetchPolicy: "cache-first",
  });

  const settings = computed(() => query.result.value?.SQDCGlobalSettings);
  const showEisenhowerPriority = computed(() => settings.value?.showEisenhowerPriority ?? false);
  const actionOrdering = computed(() => settings.value?.actionOrdering ?? TaskOrder.DESC);
  const eventOrdering = computed(() => settings.value?.eventOrdering ?? IssueOrder.DESC);
  const lisa3EventOrdering = computed(() => settings.value?.lisa3EventOrdering ?? IssueOrder.DESC);
  const lisa3ActionOrdering = computed(() => settings.value?.lisa3ActionOrdering ?? TaskOrder.ASC);
  const archiveWithoutTasks = computed(() => settings.value?.archiveWithoutTasks ?? false);
  const delegateEscalateRequired = computed(
    () => settings.value?.delegateEscalateRequired ?? false,
  );
  const eabNameTranslationKey = computed(() =>
    (settings.value?.eabName ?? SQDCEABName.LEGACY) === SQDCEABName.LEGACY
      ? "views.KPIBoard.psButton"
      : "views.KPIBoard.actionBoard",
  );

  return {
    ...query,
    settings,
    showEisenhowerPriority,
    actionOrdering,
    eventOrdering,
    lisa3EventOrdering,
    lisa3ActionOrdering,
    archiveWithoutTasks,
    eabNameTranslationKey,
    delegateEscalateRequired,
  };
}
